import type { Components, Theme } from '@mui/material/styles';

/** Every tab label at the section size, semibold — the audit tab bar, the
 *  result parts and an analysis's reports read the same. */
export const MuiTab: Components<Theme>['MuiTab'] = {
	styleOverrides: {
		root: {
			fontFamily: 'var(--font-sans)',
			fontSize: 'var(--fs-section)',
			fontWeight: 600,
			textTransform: 'none',
			minHeight: 40,
		},
	},
};
